<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <a-table v-if="addressLogList.length>0"
             :scroll="{ x: '130%' }"
             bordered
             :columns="addressColumns"
             :data-source="addressLogList"
             :pagination="false"
             :loading="loading">
      <span slot="beforeDetailedAddress" slot-scope="text, record">{{record.beforeAddress.areap}}{{record.beforeAddress.areac}}{{record.beforeAddress.areax}}{{record.beforeAddress.detailedAddress}}</span>
      <span slot="afterDetailedAddress" slot-scope="text, record">{{record.afterAddress.areap}}{{record.afterAddress.areac}}{{record.afterAddress.areax}}{{record.afterAddress.detailedAddress}}</span>
    </a-table>
    <a-table v-if="raiseLogList.length>0"
             :scroll="{ x: '130%' }"
             bordered
             :columns="raiseColumns"
             :data-source="raiseLogList"
             :pagination="false"
             :loading="loading">
    </a-table>
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
    <div style="height: 25px">

    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleCancel">
          {{$t('取消')}}
        </a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import { changeAddress,changeRaise } from '@/api/order/sell'

export default {
  name: 'ChangeLog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title:undefined,
      loading: false,
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      total:0,
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      addressLogList: [],
      raiseLogList: [],
      addressColumns: [
        {
          title: '操作时间',
          dataIndex: 'createTime',
          width: '120px'
        },
        {
          title: '变更前',
          dataIndex: 'beforeAddress',
          children: [
            {
              title: this.$t('收货人姓名'),
              dataIndex: 'beforeAddress.realName'
            },
            {
              title: this.$t('手机号'),
              dataIndex: 'beforeAddress.mobile'
            },
            {
              title: this.$t('身份证号'),
              dataIndex: 'beforeAddress.idCard'
            },
            {
              title: this.$t('地址类型'),
              dataIndex: 'beforeAddress.addressTypeName'
            },
            {
              title: this.$t('详细地址'),
              scopedSlots: { customRender: 'beforeDetailedAddress' },
            }
          ]
        },
        {
          title: '变更后',
          dataIndex: 'afterAddress',
          children: [
            {
              title: this.$t('收货人姓名'),
              dataIndex: 'afterAddress.realName'
            },
            {
              title: this.$t('手机号'),
              dataIndex: 'afterAddress.mobile'
            },
            {
              title: this.$t('身份证号'),
              dataIndex: 'afterAddress.idCard'
            },
            {
              title: this.$t('地址类型'),
              dataIndex: 'afterAddress.addressTypeName'
            },
            {
              title: this.$t('详细地址'),
              scopedSlots: { customRender: 'afterDetailedAddress' },
            }
          ]
        }
      ],
      raiseColumns: [
        {
          title: '操作时间',
          dataIndex: 'createTime',
          width: '120px'
        },
        {
          title: '变更前',
          dataIndex: 'beforeRaise',
          children: [
            {
              title: this.$t('真实姓名'),
              dataIndex: 'beforeRaise.realName'
            },
            {
              title: this.$t('身份证'),
              dataIndex: 'beforeRaise.idCard'
            },
            {
              title: this.$t('手机号'),
              dataIndex: 'beforeRaise.mobile'
            },
            {
              title: this.$t('微信'),
              dataIndex: 'beforeRaise.weChat'
            },
            {
              title: 'qq',
              dataIndex: 'beforeRaise.qq'
            },
            {
              title: this.$t('邮箱'),
              dataIndex: 'beforeRaise.email'
            }
          ]
        },
        {
          title: '变更后',
          dataIndex: 'afterRaise',
          children: [
            {
              title: this.$t('真实姓名'),
              dataIndex: 'afterRaise.realName'
            },
            {
              title: this.$t('身份证'),
              dataIndex: 'afterRaise.idCard'
            },
            {
              title: this.$t('手机号'),
              dataIndex: 'afterRaise.mobile'
            },
            {
              title: this.$t('微信'),
              dataIndex: 'afterRaise.weChat'
            },
            {
              title: 'qq',
              dataIndex: 'afterRaise.qq'
            },
            {
              title: this.$t('邮箱'),
              dataIndex: 'afterRaise.email'
            }
          ]
        }
      ]
    }
  },
  methods: {
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    handleCancel() {
      this.visible=false
      this.addressLogList=[]
      this.raiseLogList=[]
      this.reset()
    },

    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    reset() {
      this.queryParam.id = undefined
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = 10
    },
    /** 修改按钮操作 */
    handleDetail(id,type) {
      this.queryParam.id=id
      if (type === 1) {
        this.title='地址变更记录'
        changeAddress(this.queryParam).then(res => {
          this.addressLogList = res.data.records
          this.total = res.data.total
          this.visible = true;
        }).finally(() => {
          this.loading = false
        });
      } else if (type === 2) {
        this.title='应募信息变更记录'
        changeRaise(this.queryParam).then(res => {
          this.raiseLogList = res.data.records
          this.total = res.data.total
          this.visible = true;
        }).finally(() => {
          this.loading = false
        });
      }


    },
  }
}
</script>
